import type { Messages } from "../types";

export const it = {
  "common": {
    "brand": "UN8",
    "brandTag": "Incontri cristiani esclusivi",
    "continue": "Continuare",
    "leave": "Partire",
    "leaveForNow": "Lascia per ora",
    "yes": "SÌ",
    "no": "NO",
    "goBack": "Torna indietro",
    "saving": "Risparmio…",
    "submitting": "Invio...",
    "pleaseWait": "Attendere prego…",
    "ellipsis": "…",
    "male": "Maschio",
    "female": "Femmina",
    "phases": {
      "gate": "Cancello",
      "verify": "Verificare",
      "setup": "Impostare",
      "profile": "Profilo"
    },
    "storageQuota": "Questo telefono ha esaurito lo spazio per le risposte salvate. Libera spazio di archiviazione e riprova.",
    "storageDisabled": "Questo browser non salverà le tue risposte. Disattiva la modalità privata o consenti i dati del sito, quindi ricarica.",
    "charMeta": "{len}/{min} minimo · {current}/{max}",
    "charMetaMin": "minimo {min} caratteri"
  },
  "welcome": {
    "promise": "Il nostro obiettivo è eliminare questa app il più rapidamente possibile.",
    "sub": "UN8 aiuta i cristiani seri single a trovare un compagno di vita e poi ad andarsene. Verificato. I valori prima di tutto. Nessuno scorrimento infinito.",
    "signedInAs": "Accesso effettuato come {email}",
    "liveServer": "· server live",
    "deviceOnly": "· solo questo dispositivo",
    "migrateOffer": "Questo dispositivo ha ancora un profilo locale. Caricarlo sul server condiviso in modo che altri telefoni possano vederti dopo la moderazione? Non viene caricato nulla finché non scegli tu.",
    "uploadLocalProfile": "Carica il mio profilo locale",
    "keepOnDevice": "Conservalo solo su questo dispositivo",
    "migrateNeedGender": "Scegli prima Maschio o Femmina nel tuo profilo.",
    "migrateDone": "Testo del profilo caricato. Ricarica documento d'identità, video e foto in modo che la moderazione possa esaminarli.",
    "deleteConfirm": "Eliminare definitivamente il tuo account, tutti i messaggi e tutti i contenuti multimediali (inclusi ID e video) dal server?",
    "accountDeleted": "Conto eliminato.",
    "begin": "Inizio",
    "continueOnboarding": "Continua l'onboarding",
    "logIn": "Login",
    "logOut": "Esci",
    "reviewConsole": "Console di revisione",
    "matching": "Corrispondenza",
    "deleteMyAccount": "Elimina il mio account"
  },
  "faith": {
    "eyebrow": "Porta della fede",
    "title": "Solo cristiani",
    "text": "UN8 è una comunità di seguaci di Gesù Cristo, per i membri che cercano un partner orientato al matrimonio che condivida quella fede. Questo cancello non può essere saltato.",
    "yesTitle": "Sono un cristiano",
    "yesBody": "Seguo Gesù Cristo e cerco un partner orientato al matrimonio che condivida questa fede.",
    "noTitle": "Non sono cristiano",
    "noBody": "UN8 non è il posto giusto per me, e va bene così.",
    "respectTitle": "Con rispetto",
    "respectBody": "UN8 è costruito per una comunità e preferiremmo essere onesti piuttosto che farti perdere tempo. Utilizza Lascia sotto o Indietro se questa non è casa tua.",
    "sharedTitle": "Fondamento condiviso",
    "sharedBody": "Qui la fede non è un’etichetta. È il terreno sul quale ci si incontra.",
    "hintNotChristian": "UN8 è per i seguaci di Gesù Cristo. Tocca Lascia qui sotto o scegli l'opzione cristiana se sei tu.",
    "hintUnset": "Tocca \"Sono cristiano\" per continuare oppure Esci/Indietro se questa non è casa tua."
  },
  "rules": {
    "eyebrow": "Patto comunitario",
    "title": "Come ci trattiamo a vicenda",
    "text": "Affermare ogni regola. Sono necessari tutti e tre. Le violazioni comportano la rimozione definitiva. I profili falsi sono banditi per sempre.",
    "agreeContinue": "Sono d'accordo: continua",
    "respectful": {
      "title": "Sii rispettoso",
      "description": "Parla e agisci con dignità. Ogni persona qui è fatta a immagine di Dio."
    },
    "noSexualContent": {
      "title": "Nessun contenuto sessuale",
      "description": "Nessuna foto, messaggio o richiesta esplicita. La purezza qui non è un optional."
    },
    "noDominance": {
      "title": "Non dominare né controllare",
      "description": "Nessuna coercizione, manipolazione o pressione. L'amore non controlla."
    },
    "hint": "Spunta tutte e tre le promesse prima di continuare."
  },
  "intent": {
    "eyebrow": "",
    "title": "Cosa stai cercando?",
    "text": "",
    "marriage": {
      "label": "Un partner per la vita",
      "description": ""
    },
    "discernment": {
      "label": "Discernere sul serio",
      "description": ""
    },
    "notCasual": {
      "label": "Niente di superficiale",
      "description": ""
    },
    "hint": "Scegline una."
  },
  "account": {
    "eyebrow": "Account",
    "title": "Crea il tuo accesso",
    "text": "Il tuo handle crea un ID utente stabile. Applicazione, verifica, Mi piace e corrispondenze si legano tutti a quell'ID. Non viene inviata alcuna email.",
    "recoveryTitle": "Salva il codice di ripristino",
    "recoveryText": "Mostrato una volta. Senza di essa, una passphrase persa non può essere reimpostata in questo test chiuso.",
    "savedContinue": "L'ho salvato: continua",
    "handle": "Maniglia",
    "handlePlaceholder": "tu@esempio.com o un indirizzo breve",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Almeno 8 caratteri",
    "signedInTitle": "Effettuato l'accesso",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Norma di fiducia",
    "trustBody": "Nessun profilo sarà visibile finché la verifica dell'identità non sarà completata e la moderazione non ti avrà approvato.",
    "continueToVerification": "Prosegui con la verifica",
    "hintEmail": "Digitare un indirizzo e-mail che includa @.",
    "hintPassword": "Scegli una password di almeno 8 caratteri."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verifica",
      "title": "La fiducia è la porta",
      "text": "Carica un documento d'identità ufficiale, un video di conferma e foto reali {min}–{max}. Tutto entra in una coda di revisione prima che il tuo profilo possa essere visualizzato.",
      "whyTitle": "Perché verifichiamo",
      "whyBody": "Qui non c'è posto per la pesca al gatto e le mezze verità. I profili falsi sono banditi in modo permanente. Il supporto viene archiviato con lo stato pending_review fino all'approvazione.",
      "start": "Avvia la verifica"
    },
    "steps": {
      "id": {
        "title": "Carta d'identità governativa",
        "description": "Passaporto o carta d'identità nazionale: caricamento di file o fotocamera."
      },
      "video": {
        "title": "Video di conferma",
        "description": "Una breve registrazione che dimostra la tua presenza."
      },
      "photos": {
        "title": "Foto reali",
        "description": "Dalle sette alle dieci foto nitide di te stesso."
      },
      "review": {
        "title": "Revisione dell'integrità",
        "description": "I caricamenti rimangono pending_review fino alla conferma da parte dello staff."
      }
    },
    "id": {
      "eyebrow": "Passaggio 1 di 4",
      "title": "Carta d'identità governativa",
      "text": "Cattura o carica il tuo passaporto o carta d'identità nazionale. Nulla viene pubblicato pubblicamente: lo stato rimane pending_review finché lo staff non conferma.",
      "savedTitle": "ID salvato",
      "savedBody": "Poi c'è un breve video di conferma del tuo viso, poi da 7 a 10 foto reali di te stesso. Continua si sblocca quando questo ID viene visualizzato salvato.",
      "hint": "Scatta o carica una foto del tuo documento d'identità ufficiale, quindi attendi finché non viene visualizzato il messaggio Salvato."
    },
    "video": {
      "eyebrow": "Passaggio 2 di 4",
      "title": "Video di conferma",
      "text": "Registra una breve clip o caricane una. Affronta la telecamera. Parla chiaramente. Ciò dimostra che sei presente, non una galleria raschiata.",
      "hint": "Registra un breve video di conferma, quindi attendi finché non viene visualizzato il messaggio salvato."
    },
    "photos": {
      "eyebrow": "Passaggio 3 di 4",
      "title": "Foto reali",
      "text": "Aggiungi {min}–10 tue foto recenti. Usa la fotocamera o la tua libreria. Tocca × per rimuovere qualsiasi scatto.",
      "continueToReview": "Continua a rivedere",
      "hint": "Aggiungi {min} a 10 foto nitide di te stesso. Continua si sblocca quando vengono salvati."
    },
    "review": {
      "eyebrow": "Passaggio 4 di 4",
      "title": "Revisione dell'integrità",
      "text": "Il supporto è in coda come pending_review{underUser}. Corrispondenze e Mi piace utilizzeranno lo stesso ID.",
      "underUser": "sotto l'utente {userId}",
      "governmentId": "Carta d'identità governativa",
      "confirmationVideo": "Video di conferma",
      "photos": "Foto",
      "missing": "Mancante",
      "filesReady": "File {count} pronti",
      "submittedTitle": "Inviato per la revisione",
      "submittedText": "L'ID dell'applicazione è uguale all'ID dell'utente di autenticazione, quindi approva → il pool e i Mi piace reciproci rimangono allineati.",
      "submitContinue": "Invia e continua"
    }
  },
  "setup": {
    "eyebrow": "Configurazione dell'account",
    "title": "Dì la verità su te stesso",
    "text": "Queste risposte modellano la corrispondenza e vengono visualizzate nella revisione. Le bugie morbide fanno perdere tempo a tutti, compreso il tuo.",
    "beginSetup": "Inizia la configurazione",
    "pillars": {
      "faith": {
        "name": "Fede",
        "text": "Perché segui Cristo."
      },
      "character": {
        "name": "Carattere",
        "text": "Lealtà, onestà, passione, impegno: valutazione da 1 a 10."
      },
      "story": {
        "name": "Storia",
        "text": "Chi sei e cosa cerchi."
      },
      "life": {
        "name": "Vita",
        "text": "Hobby, lettura e vocazione."
      }
    },
    "whyChristian": {
      "eyebrow": "Fede",
      "title": "Perché sei cristiano?",
      "text": "Una risposta breve e onesta. Non un sermone: la ragione è tua.",
      "label": "La tua risposta",
      "placeholder": "per esempio. Ho incontrato Cristo in un periodo di smarrimento e da allora Lo seguo...",
      "hint": "Scrivi almeno {min} caratteri sul perché segui Gesù."
    }
  },
  "scales": {
    "eyebrow": "Scale di carattere",
    "title": "Valuta te stesso onestamente",
    "text": "Lealtà, onestà, passione, impegno: ciascuno da 1 a 10. Aumentare i numeri ti farà solo sbagliare in seguito. È necessario impostare ogni scala per continuare.",
    "loyalty": {
      "label": "Livello di fedeltà",
      "hint": "Sii onesto: quanto fedelmente stai al fianco di coloro che ami?"
    },
    "honesty": {
      "label": "Livello di onestà",
      "hint": "Con quale coerenza dici tutta la verità?"
    },
    "passion": {
      "label": "Quanto sei appassionato?",
      "hint": "Convinzione e profondità, non performance."
    },
    "commitment": {
      "label": "Livello di impegno",
      "hint": "Quanto sei pronto a costruire qualcosa che duri?"
    },
    "hint": "Sposta ogni cursore in modo che venga visualizzato un numero: nessuno può rimanere come un trattino."
  },
  "about": {
    "eyebrow": "A proposito di te",
    "title": "Descriviti in poche frasi",
    "text": "Chi sei quando nessuno si esibisce. Temperamento, ritmo, ciò che conta giorno per giorno.",
    "label": "A proposito di te",
    "placeholder": "Mattinate tranquille, seri riguardo alla famiglia, ridi facilmente, preferisci la profondità al rumore...",
    "hint": "Scrivi almeno {min} caratteri su di te."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Che cosa sta cercando?",
    "text": "I tratti caratteriali principali che desideri in un potenziale partner, non una lista della spesa di look.",
    "label": "Tratti caratteriali desiderati",
    "placeholder": "per esempio. Fede salda, maturità emotiva, gentilezza sotto stress...",
    "hint": "Scrivi almeno {min} caratteri sul partner che speri."
  },
  "loveReady": {
    "eyebrow": "Soglia",
    "title": "Sei pronto a incontrare l'amore della tua vita?",
    "text": "UN8 esiste in modo serio single trova un partner, quindi elimina l'app. Continuano solo gli sblocchi \"Sì\".",
    "yesTitle": "Sì, sono pronto",
    "yesBody": "Sono qui per incontrare la mia persona con chiarezza e coraggio.",
    "noTitle": "Non ancora",
    "noBody": "Se stai solo navigando, questa community non è la soluzione giusta.",
    "comeBackTitle": "Torna quando sei pronto",
    "comeBackBody": "UN8 è per le persone pronte a incontrarsi, non a raccogliere opzioni. Usa Lascia sotto se vuoi fermarti per ora. Le tue risposte vengono salvate su questo telefono.",
    "hintNo": "Solo il \"Sì\" continua. Se non sei pronto, tocca Lascia per ora: le tue risposte rimarranno su questo telefono.",
    "hintUnset": "Tocca Sì se sei pronto a incontrare qualcuno per il matrimonio."
  },
  "lifestyle": {
    "eyebrow": "Stile di vita",
    "title": "Come vivi ogni giorno",
    "text": "Sport, hobby, lettura e professione: segnali pratici per una reale compatibilità.",
    "hobbies": "Sport o hobby attuali",
    "hobbiesPlaceholder": "Ciò che fai attivamente, non quello che facevi una volta.",
    "reading": "Leggi?",
    "readingHint": "1 = quasi mai · 10 = lettura quotidiana e approfondita",
    "profession": "Professione/settore",
    "professionPlaceholder": "per esempio. Infermieristica · Software · Istruzione · Artigianato",
    "hintHobbies": "Nomina almeno uno sport o un hobby che pratichi effettivamente.",
    "hintReading": "Diapositiva \"Leggi?\" quindi viene visualizzato un numero da 1 a 10.",
    "hintProfession": "Scrivi il lavoro che fai, anche una parola breve."
  },
  "faithDepth": {
    "eyebrow": "Abbinamento · Fede",
    "title": "Quanto è centrale la tua fede?",
    "text": "Servire Dio: quanto è importante nella tua vita? Rispondi onestamente. La corrispondenza lo utilizza per la profondità, non per le prestazioni.",
    "serving": "Servire Dio: importanza",
    "servingHint": "10%...100%. Scorrere a passi di 10.",
    "keepsCommandments": "Osservi i comandamenti?",
    "grewUpInChurch": "Sei cresciuto in chiesa?",
    "churchAttendance": "Frequenza in chiesa",
    "frequent": {
      "label": "Frequente",
      "hint": "Incontro regolare con il corpo di Cristo."
    },
    "seldom": {
      "label": "Raramente",
      "hint": "Occasionalmente, non un ritmo settimanale."
    },
    "never": {
      "label": "Mai",
      "hint": "Attualmente non partecipo."
    },
    "spreadsGospel": "Diffondi il Vangelo?",
    "hasIdols": "Hai degli idoli?",
    "hintServing": "Fai scorrere quanto è importante servire Dio nella tua vita.",
    "hintCommandments": "Rispondi se rispetti i comandamenti: sì o no.",
    "hintGrewUp": "Rispondi se sei cresciuto in chiesa: sì o no.",
    "hintAttendance": "Scegli quanto spesso frequenti la chiesa.",
    "hintGospel": "Rispondi se condividi il Vangelo: sì o no.",
    "hintIdols": "Rispondi se hai idoli: sì o no."
  },
  "character": {
    "eyebrow": "Abbinamento · Carattere",
    "title": "Chi sei a casa",
    "text": "Carattere per il corteggiamento: pacificazione, buone maniere, onestà. Le risposte gonfiate non ti corrispondono solo in seguito.",
    "peacemaker": "Sei un pacificatore?",
    "homebuilder": "Sei un costruttore di case?",
    "humorous": "Sei divertente?",
    "caring": "Premuroso e affettuoso?",
    "peacefulHome": "Vuoi una casa pacifica, senza combattimenti?",
    "manners": "Buone maniere?",
    "honestyRating": "Valutazione dell'onestà su questo questionario",
    "honestyHint": "1–10: quanto rispondi onestamente?",
    "hintPeacemaker": "Rispondi a ciascun Sì o No, iniziando con Peacemaker.",
    "hintHomebuilder": "Rispondi se sei un costruttore di case.",
    "hintHumorous": "Rispondi se sei spiritoso.",
    "hintCaring": "Rispondi se sei premuroso e affettuoso.",
    "hintPeaceful": "Rispondi se desideri una casa tranquilla.",
    "hintManners": "Rispondi se hai buone maniere.",
    "hintHonesty": "Fai scorrere il tuo punteggio di onestà da 1 a 10."
  },
  "history": {
    "eyebrow": "Abbinamento · Storia",
    "title": "Passato e prontezza",
    "text": "Sostanze, infanzia, cicatrici e se sei pronto per una relazione duratura. La verità qui vi protegge entrambi.",
    "marijuana": "Hai usato marijuana?",
    "lsd": "Hai usato LSD?",
    "otherDrugs": "Hai usato altri farmaci?",
    "addicted": "Sei stato dipendente?",
    "childhood": "Infanzia stabile e amorevole?",
    "scars": "Qualche cicatrice/danneggiato?",
    "lasting": "Pronto per una relazione duratura?",
    "hintStart": "Rispondi a ogni sì o no in questa pagina, iniziando dall'alto.",
    "hintLsd": "Rispondi alla domanda sull'LSD: sì o no.",
    "hintOtherDrugs": "Rispondi se hai usato altri farmaci.",
    "hintAddicted": "Rispondi se sei stato dipendente.",
    "hintChildhood": "Rispondi se la tua infanzia è stata stabile e amorevole.",
    "hintScars": "Rispondi se porti cicatrici.",
    "hintLasting": "Rispondi se sei pronto per una relazione duratura."
  },
  "appearance": {
    "eyebrow": "Corrispondenza · Aspetto",
    "title": "Tatuaggi",
    "text": "I tuoi tatuaggi e se i tatuaggi su un partner sono accettabili per te.",
    "hasTattoos": "Hai tatuaggi?",
    "acceptsPartner": "Accetti i tatuaggi su un partner?",
    "hintHas": "Di' se hai dei tatuaggi: sì o no.",
    "hintAccepts": "Di' se i tatuaggi su un partner sono accettabili per te."
  },
  "home": {
    "eyebrow": "Abbinamento · Casa e terreno",
    "title": "Terra, competenze, autosufficienza",
    "text": "Erbe, coltivazione di cibo, frutticoltura, preparazione, agricoltura comunitaria, conservazione, sopravvivenza e qualsiasi abilità speciale.",
    "herbKnowledge": "Conoscenza delle erbe?",
    "plantOwn": "Pianti tu stesso frutta e verdura?",
    "fruitForest": "Ti interessa un bosco da frutto?",
    "prepping": "Prepararsi alle calamità?",
    "communityFarming": "Agricoltura comunitaria/vita indipendente?",
    "canning": "Inscatolare e conservare?",
    "survival": "Abilità di sopravvivenza?",
    "specialSkills": "Abilità speciali (facoltativo)",
    "specialPlaceholder": "Qualsiasi altra cosa porti a una famiglia o a un terreno...",
    "hintStart": "Rispondi a ogni sì o no su terreno e abilità, iniziando dall'alto.",
    "hintPlant": "Rispondi se pianti la tua frutta e verdura.",
    "hintFruitForest": "Rispondi se ti interessa un bosco da frutto.",
    "hintPrepping": "Rispondi se ti prepari per le calamità.",
    "hintCommunity": "Rispondi se l'agricoltura comunitaria ti interessa.",
    "hintCanning": "Rispondi se puoi e conserva il cibo.",
    "hintSurvival": "Rispondi se hai capacità di sopravvivenza."
  },
  "family": {
    "eyebrow": "Abbinamento · Famiglia",
    "title": "I bambini, la profondità della fede, le sostanze",
    "text": "Ciò di cui hai bisogno in un partner sull'intensità della fede, figli, e uso passato di sostanze.",
    "children": "Bambini",
    "wants": {
      "label": "Vuole figli",
      "hint": "Costruire una famiglia fa parte della visione."
    },
    "doesNotWant": {
      "label": "Non vuole figli",
      "hint": "No netto ai bambini."
    },
    "open": {
      "label": "Aprire",
      "hint": "Esigente: non bloccato in ogni caso."
    },
    "hasLivingWith": {
      "label": "Ha figli e vive con loro",
      "hint": "I bambini fanno già parte della vita quotidiana."
    },
    "requiredFaith": "Livello minimo di fiducia di cui hai bisogno in un partner",
    "requiredFaithHint": "10%...100%. Cancello difficile quando entrambe le parti hanno risposto.",
    "acceptsSubstances": "Accettare l'uso passato di sostanze in un partner?",
    "hintChildren": "Scegli una carta sui bambini.",
    "hintFaith": "Fai scorrere il livello minimo di fiducia che speri in un partner.",
    "hintSubstances": "Dire se l'uso passato di sostanze da parte di un partner è accettabile."
  },
  "ancestry": {
    "eyebrow": "Corrispondenza · Sfondo",
    "title": "Preferenze di sfondo",
    "text": "Condividi il tuo background e ciò a cui sei aperto in un partner. Questo determina solo la classifica: non nasconde mai qualcuno dal mazzo.",
    "yourBackground": "Il tuo background (seleziona tutte le risposte pertinenti)",
    "openToPartner": "Aperto a un partner",
    "codeDesc": "Codice: {code}",
    "anyDesc": "Preferenza più forte per l'ampiezza: consigliata in caso di dubbi.",
    "preferenceOnly": "Solo preferenza, non un cancello.",
    "hintOwn": "Seleziona almeno uno sfondo che ti descrive. Questo aiuta solo a classificarsi: non nasconde mai nessuno.",
    "hintAccepted": "Seleziona ciò a cui sei aperto in un partner o \"Aperto - nessuna preferenza\"."
  },
  "interests": {
    "eyebrow": "Corrispondenza · Interessi",
    "title": "Ciò che ti piace",
    "text": "Scegline almeno uno. La sovrapposizione aiuta il posizionamento; il silenzio non è mai punito.",
    "hint": "Seleziona almeno un interesse."
  },
  "reflection": {
    "eyebrow": "Abbinamento · Riflessione",
    "title": "Con parole tue",
    "text": "Queste quattro risposte sono mostrate per intero e non vengono mai valutate. Scrivi ciò che è vero.",
    "describeYourself": "Descrivi te stesso",
    "lifePurpose": "Scopo della vita",
    "fifteenYear": "Tu e l'amore della tua vita tra 15 anni",
    "weaknesses": "Punti deboli",
    "hintDescribe": "Descriviti utilizzando almeno {min} caratteri.",
    "hintPurpose": "Scrivi lo scopo della tua vita almeno in caratteri {min}.",
    "hintVision": "Scrivi la visione di 15 anni almeno in caratteri {min}.",
    "hintWeaknesses": "Nomina un punto debole composto da almeno {min} caratteri."
  },
  "profile": {
    "eyebrow": "Profilo",
    "title": "Alcuni elementi essenziali",
    "text": "Mantienilo semplice. Il sesso qui è binario – maschio o femmina – per una corrispondenza chiara.",
    "firstName": "Nome di battesimo",
    "firstNamePlaceholder": "Come desideri essere conosciuto",
    "age": "Età",
    "agePlaceholder": "18+",
    "city": "Città",
    "cityPlaceholder": "Dove risiedi",
    "sex": "Sesso",
    "maleBody": "Sono un uomo.",
    "femaleBody": "Sono una donna.",
    "hintName": "Digita il tuo nome (almeno due lettere).",
    "hintAge": "L'età deve essere maggiore di 18 anni.",
    "hintCity": "Digita la città in cui vivi.",
    "hintGender": "Scegli Maschio o Femmina in modo che l'abbinamento possa funzionare."
  },
  "ready": {
    "title": "Puoi entrare.",
    "textNamed": "{name}, la verifica e la configurazione vengono registrate. Il supporto è pending_review. Benvenuto in UN8: trova la tua persona, quindi elimina l'app.",
    "text": "La verifica e la configurazione vengono registrate. Il supporto è pending_review. Benvenuto in UN8: trova la tua persona, quindi elimina l'app.",
    "summaryAria": "Riepilogo della configurazione",
    "christianRules": "· Regole cristiane affermate",
    "mediaLine": "ID · video · foto {photoCount} · coda {pending}",
    "scalesLine": "Scale L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sesso—",
    "professionFallback": "professione",
    "userLine": "Utente {userId}",
    "enterMatching": "Inserisci la corrispondenza",
    "needGender": "Torna al passaggio del profilo e scegli Maschio o Femmina, quindi riprova."
  },
  "match": {
    "brandTag": "Corrispondenza",
    "navOnboarding": "Onboarding",
    "navReview": "Revisione",
    "navMatching": "Corrispondenza",
    "logOut": "Esci",
    "enterTitle": "Inserisci la corrispondenza",
    "enterText": "Accedi con la stessa email dell'onboarding. Applicazione, pool, Mi piace e corrispondenze utilizzano tutti il ​​tuo ID utente stabile.",
    "email": "E-mail",
    "emailPlaceholder": "tu@esempio.com",
    "password": "Password",
    "passwordPlaceholder": "La tua password",
    "logIn": "Login",
    "guestOr": "Oppure prova una sessione ospite (ID stabile per browser · solo demo)",
    "guestMan": "Ospite come uomo",
    "guestWoman": "Ospite come donna",
    "goOnboarding": "Vai all'onboarding →",
    "guestSession": "Sessione ospite · pool demo",
    "packTitle": "I tuoi quattro",
    "packSkip": "Tocca per continuare",
    "newSelection": "Nuova selezione",
    "backToFour": "← Torna ai tuoi quattro",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "Uomo",
    "woman": "donna",
    "navSelection": "Selezione",
    "navMessages": "Messaggi",
    "navProfile": "Profilo",
    "tabToday": "Selezione",
    "tabMatches": "Partite ({count})",
    "yourMatches": "Le tue partite",
    "matchesSub": "Interesse reciproco persistente · {count} {likesWord} in uscita",
    "like": "Piace",
    "likes": "piace",
    "emptyMatches": "Nessun interesse reciproco ancora. Continua a discernere la selezione di questa settimana.",
    "valuesScore": "Valori {score}",
    "chatOpen": "· Chat aperta",
    "tapToChat": "· Tocca per chattare",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Valori {score}",
    "noProfileYet": "Nessun profilo ancora",
    "noProfileText": "Termina l'onboarding oppure tocca Onboarding in alto, quindi Inizia. L'abbinamento degli ospiti è nella schermata di accesso se vuoi solo guardare.",
    "matchingPaused": "Corrispondenza sospesa",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Nessuno da mostrare ancora",
    "todaysSetDone": "Questa è la selezione di questa settimana",
    "weeklyTitle": "I tuoi 4 di questa settimana",
    "weeklyTitleCount": "I tuoi {count} di questa settimana",
    "weeklyCountdown": "Prossima selezione tra {days} giorni",
    "weeklyCountdownOne": "Prossima selezione tra 1 giorno",
    "weeklyCountdownSoon": "Prossima selezione a breve",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Questa è la selezione di questa settimana",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Non c’è nessuno nella lista di questa settimana. Il gruppo si sta riempiendo — riapri Selezione tra un attimo, o torna quando altri membri saranno approvati.",
    "emptyDone": "Hai esaminato la selezione di questa settimana. Torna alla prossima apertura, o reimposta il mazzo.",
    "likesMayNotStick": "I Mi piace potrebbero non rimanere.",
    "poolMeta": "Girone: {pool} · Partite: {matches} · Piaciuto: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Ripristina il mazzo",
    "backOnboarding": "Torniamo all'onboarding",
    "feedEyebrowDemo": "Selezione settimanale · Demo",
    "feedEyebrowLive": "Selezione settimanale · Pool ({source}, {count})",
    "feedTitle": "Discernere con attenzione",
    "left": "ne restano {count}",
    "pass": "Passaggio",
    "interested": "Interessato",
    "swipeHint": "Scorri o utilizza i pulsanti. Una partita si apre solo quando l’interesse è reciproco e persistente.",
    "celebrationEyebrow": "Interesse reciproco",
    "celebrationTitle": "Hai abbinato",
    "celebrationText": "{self} e {other} hanno entrambi mostrato interesse. Allineamento valori: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "La chat è sbloccata per questa partita. Mantieni il rispetto: patto piuttosto che convenienza.",
    "openChat": "Apri la chat",
    "keepDiscerning": "Continua a discernere",
    "cardSeeking": "Cercando",
    "cardHobbies": "Hobby",
    "affinity": "Affinità",
    "valuesScoreLabel": "Punteggio di valori",
    "scoreStrong": "Forte allineamento",
    "scoreSolid": "Allineamento solido",
    "scoreModerate": "Allineamento moderato",
    "scoreDifferent": "Ritmi diversi",
    "characterAxisFoot": "L'asse del carattere comprende i quattro pilastri",
    "youThem": "Tu {self} · Loro {other}",
    "stampInterest": "Interesse",
    "stampPass": "Passaggio",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "I punteggi dei tuoi valori sono vicini ({score} di 100).",
    "explainLegacyFuller": "Un \"perché\" più completo appare dopo che entrambi avete finito le domande corrispondenti.",
    "explainFaith": "La tua intensità di fede è vicina: segui Gesù con la stessa serietà.",
    "explainCharacter": "Il modo in cui tratti le persone a casa è in linea: pace, buone maniere e cura.",
    "explainPurpose": "Hai valutato la tua onestà in modo simile, il che è un segno di serietà condivisa.",
    "explainHome": "Condividi l'interesse per la terra, la coltivazione del cibo o una casa autosufficiente.",
    "explainAncestry": "Entrambi preferite background familiari simili. Questa è una preferenza, non un filtro: nessuno si nasconde per questo.",
    "explainTemperament": "I tuoi interessi e il tuo temperamento si sovrappongono.",
    "explainFallback": "Esiste una possibile corrispondenza tra le risposte che avete inserito entrambi.",
    "explainOverall": "Affinità complessiva {score} di 100.",
    "affinityAxes": {
      "faith": "Intensità della fede",
      "character": "Carattere e condotta",
      "purpose": "Allineamento dello scopo della vita",
      "home": "Casa e autosufficienza",
      "ancestry": "Affinità culturale e di background",
      "temperament": "Adattamento al temperamento"
    },
    "scaleAxes": {
      "loyalty": "Lealtà",
      "honesty": "Onestà",
      "passion": "Passione",
      "commitment": "Impegno"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chiacchierata",
    "unavailableTitle": "Chat non disponibile",
    "unavailableText": "Questa corrispondenza manca o non appartiene alla tua sessione.",
    "backToMatches": "Torniamo alle partite",
    "backMatches": "← Partite",
    "valuesSubscriber": "Valori {score} · Abbonato",
    "valuesTrial": "Valori {score} · Prova",
    "valuesKept": "Valori {score} · Corrispondenza mantenuta",
    "empty": "Saluta con attenzione. Sul backend condiviso, i messaggi si sincronizzano su entrambi i telefoni dopo una corrispondenza reciproca.",
    "placeholder": "Messaggio {name}…",
    "ariaMessage": "Messaggio",
    "send": "Inviare"
  },
  "billing": {
    "paywallCopy": "Dopo la prova gratuita, mantieni tutti quelli con cui ti sei già abbinato e continua a chattare. Per vedere nuove persone, iscriviti.",
    "signInToMatch": "Accedi per utilizzare la corrispondenza.",
    "signInFirst": "Accedi prima.",
    "subscriberUntil": "Abbonato · fino al {date}",
    "renewal": "rinnovo",
    "freeTrial": "Prova gratuita · {days} giorni (termina {date})",
    "soon": "Presto",
    "trialEnded": "Prova terminata · partite e chat restano aperte",
    "subscribe": "Iscriviti · ${price}/mese",
    "subscribeEarly": "Iscriviti in anticipo · ${price}/mese",
    "activeNote": "Abbonamento attivo: puoi rivedere nuove persone.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Salva il codice di ripristino",
    "recoveryText": "Scrivilo adesso. Viene mostrato una volta. Se perdi la passphrase, questo codice è l'unico modo per reimpostarla nel test chiuso.",
    "savedContinue": "L'ho salvato: continua",
    "welcomeBack": "Bentornato",
    "createAccount": "Crea il tuo account",
    "intro": "Handle e passphrase. Non viene inviata alcuna email o SMS. Il tuo ID rimane stabile durante l'onboarding, la revisione e l'abbinamento.",
    "tabLogin": "Login",
    "tabRegister": "Registro",
    "handle": "Maniglia",
    "handlePlaceholder": "tu@esempio.com o un indirizzo breve",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "Almeno 8 caratteri",
    "submitLogin": "Login",
    "submitRegister": "Creare un account",
    "backWelcome": "Torniamo a dare il benvenuto"
  },
  "options": {
    "origin": {
      "african": "africano",
      "european": "europeo",
      "asian": "asiatico",
      "latino": "Latino/ispanico",
      "middleEastern": "Medio Orientale",
      "indigenous": "Indigeno",
      "mixed": "Misto",
      "other": "Altro",
      "dutch": "Olandese",
      "german": "tedesco",
      "any": "Aperto: nessuna preferenza"
    },
    "interest": {
      "prayer": "Preghiera",
      "worship": "Culto",
      "reading": "Lettura",
      "hiking": "Escursionismo",
      "music": "Musica",
      "cooking": "Cucina",
      "farming": "Agricoltura/giardinaggio",
      "sports": "Sport",
      "missions": "Missioni",
      "family": "Vita familiare",
      "crafts": "Artigianato",
      "outdoors": "All'aperto"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "SÌ",
      "no": "NO"
    },
    "id": {
      "titleEmpty": "Carta d'identità governativa",
      "titleReady": "Carta d'identità pronta",
      "hintEmpty": "Passaporto o carta d'identità nazionale. Scatta una foto dal vivo o scegli un'immagine/PDF. Tutti e quattro gli angoli visibili.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· salvato",
      "previewAlt": "Anteprima del documento d'identità governativo",
      "pdfAria": "Documento PDF selezionato",
      "takePhoto": "Scatta foto",
      "retake": "Riprendere",
      "chooseFile": "Scegli file",
      "replaceFile": "Sostituisci file",
      "remove": "Rimuovere",
      "uploading": "Caricamento…",
      "cameraTitle": "Fotografa il tuo documento d'identità",
      "signIn": "Accedi prima di caricare l'ID.",
      "uploadFailed": "Caricamento non riuscito. Riprova.",
      "badFile": "Impossibile utilizzare questo file."
    },
    "video": {
      "titleEmpty": "Video di conferma",
      "titleLive": "Telecamera in diretta",
      "titleReady": "Video pronto",
      "hintEmpty": "Dì il tuo nome e dichiara di iscriverti a UN8 onestamente. 5–15 secondi.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Documentazione",
      "cameraUpload": "Caricamento della fotocamera",
      "chooseFile": "Scegli file",
      "startRecording": "Inizia a registrare",
      "cancel": "Cancellare",
      "stopSave": "Fermati e salva",
      "recordAgain": "Registra di nuovo",
      "replaceFile": "Sostituisci file",
      "remove": "Rimuovere",
      "unsupported": "La registrazione dal vivo non è disponibile qui. Utilizza il caricamento da fotocamera o scegli un file.",
      "permissionDenied": "Autorizzazione della fotocamera negata. Puoi comunque caricare un breve file video.",
      "signIn": "Accedi prima di caricare il video.",
      "uploadFailed": "Caricamento non riuscito. Riprova.",
      "saveFailed": "Impossibile salvare la registrazione.",
      "badVideo": "Impossibile utilizzare questo video."
    },
    "photos": {
      "count": "Foto {count} / {max}",
      "minimumMet": "Minimo raggiunto",
      "moreRequired": "{n} più richiesto",
      "listAria": "Foto di verifica",
      "photoAlt": "Foto {n}",
      "removeAria": "Rimuovi la foto {n}",
      "camera": "Telecamera",
      "takePhoto": "Scatta foto",
      "chooseFiles": "Scegli i file",
      "uploading": "Caricamento…",
      "hint": "Scatta foto apre la fotocamera live. La scelta dei file è disponibile solo per le scelte della galleria. Scatti chiari dei volti: nessun filtro che nasconde l'identità. Massimo {max}.",
      "cameraTitle": "Scatta una foto di te stesso",
      "signIn": "Accedi prima di caricare le foto.",
      "someFailed": "Impossibile caricare alcune foto. Riprova quelli falliti.",
      "addFailed": "Impossibile aggiungere foto."
    },
    "liveStill": {
      "titleDefault": "Telecamera",
      "close": "Vicino",
      "capture": "Catturare",
      "cancel": "Cancellare",
      "hint": "Tieni duro. La telecamera live rimane aperta finché non acquisisci.",
      "unavailable": "La fotocamera non è disponibile in questo browser. Utilizzare invece Scegli file.",
      "permissionDenied": "Autorizzazione fotocamera negata o non disponibile. Utilizzare invece Scegli file.",
      "frameFailed": "Impossibile acquisire questo fotogramma.",
      "saveFailed": "Impossibile salvare la foto."
    },
    "uploadStatus": {
      "uploading": "caricamento…",
      "failed": "caricamento non riuscito",
      "savedLocally": "salvato localmente",
      "uploaded": "caricato",
      "stored": "memorizzato",
      "awaitingUpload": "In attesa di caricamento",
      "localFallbackNote": "{error} Il file viene salvato su questo dispositivo; riprovare quando l'endpoint del segno è attivo."
    }
  },
  "language": {
    "label": "Lingua",
    "choose": "Scegli la lingua"
  },
  "shell": {
    "back": "Indietro",
    "goBackAria": "Torna indietro"
  }
} as Messages;
